import React, { Suspense } from "react";
import { PropTypes } from "prop-types";
import { useNavigate } from "react-router-dom";
import reactWrapper from "@harbor/elements/utils/react/wrapper";
import {
  setLocalStorageFlag,
  getTextValueTopSites,
  updateCookie
} from "../../../utils/common";
import {
  formatNumberNDecimalPlaces,
  formatBytes,
  formatString
} from "../../../utils/format";
import { getTextColor } from "../../../utils/colors";
import { tViews } from "../../../utils/table"
import "../../commonMagneticStyle.less";
import Spinner from "../../../common/Spinner";
import NoDataAvailable from "../../../common/NoDataAvailable";
import { routeURLs } from "../../../utils/enums";
import { getCookie } from "../../../serviceWorker";
import { getVManageMonitorUrl } from "../../../utils/vManageNavigation";

const [HbrTable] = reactWrapper(["hbr-table"]);

const TopSitesComponent = props => {
  const { sites, sitesView } = props;
  const navigate = useNavigate();
  const textVaue = getTextValueTopSites(sitesView);

  const getSiteDetails = siteId => {
    const isUIconvergence = getCookie("cl-analytics");

    if (isUIconvergence) {
      updateCookie("currentSite", siteId);
      window.location.href = getVManageMonitorUrl("/overview");
    } else {
      setLocalStorageFlag("currentSite", siteId);
      props.setSelectedSite(siteId);
      navigate(routeURLs.overview);
    }
  };

  const score = props.isReporting ?
    {
      prop: "vqoe_score",
      name: tViews('allSiteQoELabel'),
      size: 100,
      cellTemplate: (createElement, props) => {
        const div = createElement("div", {
          style: {
            color: getTextColor(props.model.vqoe_score, "qoe")
          },
          innerHTML: props.model.vqoe_score
        });
        return [div];
      }
    } :
    {
      prop: "availability",
      name: textVaue.secondColHeader,
      size: 110,
      cellTemplate: (createElement, props) => {
        const div = createElement("div", {
          style: {
            color: getTextColor(props.model.availability, "availability")
          },
          innerHTML: props.model.availability
        });
        return [div];
      }
    };

  const columns = [
    {
      prop: "index",
      name: "#",
      size: 50
    },
    {
      prop: "site_id",
      name: tViews('allSiteSiteLabel'),
      size: 120,
      cellTemplate: (createElement, props) => {
        const getHTML = () =>
          `<hbr-link class="application-trending-apps-qoe-widget-link" id="sites-top-site-map-${props.model.site_name}">${props.model.siteNameDisplay}</hbr-link>
                <hbr-portal>
                  <hbr-tooltip anchor="#sites-top-site-map-${props.model.site_name}">
                    <div slot="content">
                        <strong>${props.model.site_name}</strong>  
                    </div>
                  </hbr-tooltip>
                </hbr-portal>`;
        const div = createElement("div", {
          content: `<div>${props.model.site_name}</div>`,
          innerHTML: getHTML(),
          onClick: e => {
            if (e && e.target) {
              getSiteDetails(props.model.site_id);
            }
          }
        });
        return [div];
      }
    },
    {
      prop: "city",
      name: tViews('allSiteLocationLabel'),
      size: 120
    },
    {
      ...score
    },
    {
      prop: "usageFormatted",
      name: textVaue.thirdColHeader,
      size: 90
    }
  ];
  sites && sites.length > 0 && sites.map((site, index) => {
    site.index = index + 1;
    site.usageFormatted = formatBytes(site.usage);
    site.availability = parseFloat(
      formatNumberNDecimalPlaces(site.availability, 1)
    );
    site.siteNameDisplay = formatString(site.site_name,12);
  });
  const source = sites;

  return (
    <>
      <div className="top-sites-heading hbr-type-body3">{textVaue.viewBy}</div>
      {Object.keys(source).length === 0 ? (
        <Suspense fallback={<Spinner />}>
          <div className="top-sites-no-data">
            <NoDataAvailable />
          </div>
        </Suspense>
      ) : (
          <HbrTable
            className="site-table"
            readonly
            canFocus={false}
            columns={columns}
            source={source}
          />
        )}
    </>
  );
};

TopSitesComponent.propTypes = {
  sites: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  setSelectedSite: PropTypes.func,
  globalFilter: PropTypes.object,
  model: PropTypes.object,
  sitesView: PropTypes.string.isRequired,
  isReporting: PropTypes.bool
};

export default TopSitesComponent;
